import React, { useMemo } from 'react';
import { View, ScrollView } from 'react-native';
import PropTypes from 'prop-types';
import { Footer, Background, ActivityIndicator } from 'LocalGluons';
import { getActualHeight, getActualWidth, WEB_WIDTH } from 'DeviceUtils';
import { useAppSelector } from 'ReduxStore/hooks';
import { TOP_BAR_TOTAL_HEIGHT } from '../../Navigation/Menu/Menu.styles';

const WRAPPER_STYLE = {
    flex: 1,
    transition: 'margin .16s linear'
};
const MINIMISED_STYLE = {
    flex: 1,
    transition: 'margin .16s linear'
};

const WrapperContainer = ({ noScrollView, onScroll, scrollEventThrottle, children }) => {
    const isMinimised = useAppSelector((state) => state.webMenu.isMinimised);

    if (noScrollView) {
        return <View style={isMinimised ? MINIMISED_STYLE : WRAPPER_STYLE}>{children}</View>;
    }

    return (
        <ScrollView
            onScroll={onScroll}
            scrollEventThrottle={scrollEventThrottle}
            contentContainerStyle={{ ...WRAPPER_STYLE, paddingTop: TOP_BAR_TOTAL_HEIGHT }}
        >
            <View
                style={{
                    width: WEB_WIDTH,
                    alignSelf: 'center',
                    minHeight: getActualHeight(),
                    zIndex: 99
                }}
            >
                {children}
            </View>
            <Footer />
        </ScrollView>
    );
};

const ContentWrapper = ({
    children,
    loading,
    onScroll,
    scrollEventThrottle,
    noScrollView,
    style
}) => {
    const resolvedChildren = typeof children === 'function' ? children(Footer) : children;

    return (
        <Background style={{ ...style, flex: 1 }} noPadding>
            <WrapperContainer
                noScrollView={noScrollView}
                onScroll={onScroll}
                scrollEventThrottle={scrollEventThrottle}
            >
                {!loading && resolvedChildren}
                {loading && (
                    <View style={{ flex: 1 }}>
                        <ActivityIndicator />
                    </View>
                )}
            </WrapperContainer>
        </Background>
    );
};

ContentWrapper.defaultProps = {
    loading: false,
    onScroll: () => {},
    scrollEventThrottle: 250
};

ContentWrapper.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    onScroll: PropTypes.func,
    scrollEventThrottle: PropTypes.number,
    loading: PropTypes.bool
};

export default ContentWrapper;
